
import WCBasicAddToCartButton from '@/modules/cart/components/WCBasicAddToCartButton/WCBasicAddToCartButton.vue';
import HidePricingMixin from '@/mixins/HidePricingMixin';
import { PropType, defineComponent } from 'vue';
import ItemDetail from '@/models/entities/items/item-detail';

export default defineComponent({
  components: { WCBasicAddToCartButton },
  mixins: [HidePricingMixin],
  props: {
    item: {
      type: Object as PropType<ItemDetail>,
      required: true,
    },
    showAddToCartButton: {
      type: Boolean,
      default: true,
    },
  },
});
